export default {
    methods: {
        autoLink: function(content) {
            var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
            var regex = new RegExp(expression);

            var updatedPosition = 0;
            while(true) {
                var checkedPart = content.substr(0, updatedPosition);
                var uncheckedPart = content.substr(updatedPosition);
                regex.lastIndex = 0;
                var match = regex.exec(uncheckedPart);
                if (match) {
                    var url = match[0];
                    var linkedUrl = "<a href='" + url + "' target='_blank'>" + url + "</a>";
                    var replaced = uncheckedPart.replace(url, linkedUrl);
                    content = checkedPart + replaced;
                    updatedPosition = checkedPart.length + match.index + linkedUrl.length;
                } else {
                    break;
                }
            }
            return content;
        }
    }
}
